export const AUTH_API_PREFIX = '/auth'

export enum ApiUrls {
  AUTH_SIGN_UP_URL = '/v1/signup',
  AUTH_TOKEN_URL = '/v1/token',
  AUTH_REVOKE_URL = '/v1/revoke',
  WEDA_USER_URL = '/v1/plugin/weda/userinfo',
  AUTH_RESET_PASSWORD = '/v1/reset',
  AUTH_GET_DEVICE_CODE = '/v1/device/code',
  CHECK_USERNAME = '/v1/checkUsername',
  CHECK_IF_USER_EXIST = '/v1/checkIfUserExist',
  GET_PROVIDER_TYPE = '/v1/mgr/provider/providerSubType',

  AUTH_SIGN_IN_URL = '/v1/signin',
  AUTH_SIGN_IN_ANONYMOUSLY_URL = '/v1/signin/anonymously',
  AUTH_SIGN_IN_WITH_PROVIDER_URL = '/v1/signin/with/provider',
  AUTH_SIGN_IN_WITH_WECHAT_URL = '/v1/signin/wechat/noauth',
  AUTH_SIGN_IN_CUSTOM = '/v1/signin/custom',

  PROVIDER_TOKEN_URL = '/v1/provider/token',
  PROVIDER_URI_URL = '/v1/provider/uri',

  USER_ME_URL = '/v1/user/me',
  AUTH_SIGNOUT_URL = '/v1/user/signout',
  USER_QUERY_URL = '/v1/user/query',
  USER_PRIFILE_URL = '/v1/user/profile',
  USER_BASIC_EDIT_URL = '/v1/user/basic/edit',
  USER_TRANS_BY_PROVIDER_URL = '/v1/user/trans/by/provider',
  PROVIDER_LIST = '/v1/user/provider',
  PROVIDER_BIND_URL = '/v1/user/provider/bind',
  PROVIDER_UNBIND_URL = '/v1/user/provider',
  CHECK_PWD_URL = '/v1/user/sudo',
  SUDO_URL = '/v1/user/sudo',
  BIND_CONTACT_URL = '/v1/user/contact',
  AUTH_SET_PASSWORD = '/v1/user/password',
  AUTHORIZE_DEVICE_URL = '/v1/user/device/authorize',
  AUTHORIZE_URL = '/v1/user/authorize',
  AUTHORIZE_INFO_URL = '/v1/user/authorize/info',
  AUTHORIZED_DEVICES_DELETE_URL = '/v1/user/authorized/devices/',
  AUTH_REVOKE_ALL_URL = '/v1/user/revoke/all',
  GET_USER_BEHAVIOR_LOG = '/v1/user/security/history',

  VERIFICATION_URL = '/v1/verification',
  VERIFY_URL = '/v1/verification/verify',

  CAPTCHA_DATA_URL = '/v1/captcha/data',
  VERIFY_CAPTCHA_DATA_URL = '/v1/captcha/data/verify',
  GET_CAPTCHA_URL = '/v1/captcha/init',

  GET_MINIPROGRAM_QRCODE = '/v1/qrcode/generate',
  GET_MINIPROGRAM_QRCODE_STATUS = '/v1/qrcode/get/status',
}

export enum ApiUrlsV2 {
  AUTH_SIGN_IN_URL = '/v2/signin/username',
  AUTH_TOKEN_URL = '/v2/token',
  USER_ME_URL = '/v2/user/me',
  VERIFY_URL = '/v2/signin/verificationcode',
  AUTH_SIGN_IN_WITH_PROVIDER_URL = '/v2/signin/with/provider',
  AUTH_PUBLIC_KEY = '/v2/signin/publichkey',
  AUTH_RESET_PASSWORD = '/v2/signin/password/update',
}

export enum VerificationUsages {
  REGISTER = 'REGISTER',
  SIGN_IN = 'SIGN_IN',
  PASSWORD_RESET = 'PASSWORD_RESET',
  EMAIL_ADDRESS_CHANGE = 'EMAIL_ADDRESS_CHANGE',
  PHONE_NUMBER_CHANGE = 'PHONE_NUMBER_CHANGE',
}

export enum ErrorType {
  UNREACHABLE = 'unreachable',
  LOCAL = 'local',
  CANCELLED = 'cancelled',
  UNKNOWN = 'unknown',
  UNAUTHENTICATED = 'unauthenticated',
  RESOURCE_EXHAUSTED = 'resource_exhausted',
  FAILED_PRECONDITION = 'failed_precondition',
  INVALID_ARGUMENT = 'invalid_argument',
  DEADLINE_EXCEEDED = 'deadline_exceeded',
  NOT_FOUND = 'not_found',
  ALREADY_EXISTS = 'already_exists',
  PERMISSION_DENIED = 'permission_denied',
  ABORTED = 'aborted',
  OUT_OF_RANGE = 'out_of_range',
  UNIMPLEMENTED = 'unimplemented',
  INTERNAL = 'internal',
  UNAVAILABLE = 'unavailable',
  DATA_LOSS = 'data_loss',
  // CommonError
  INVALID_PASSWORD = 'invalid_password',
  PASSWORD_NOT_SET = 'password_not_set',
  INVALID_STATUS = 'invalid_status',
  USER_PENDING = 'user_pending',
  USER_BLOCKED = 'user_blocked',
  INVALID_VERIFICATION_CODE = 'invalid_verification_code',
  TWO_FACTOR_REQUIRED = 'two_factor_required',
  INVALID_TWO_FACTOR = 'invalid_two_factor',
  INVALID_TWO_FACTOR_RECOVERY = 'invalid_two_factor_recovery',
  UNDER_REVIEW = 'under_review',
  INVALID_REQUEST = 'invalid_request',
  UNAUTHORIZED_CLIENT = 'unauthorized_client',
  ACCESS_DENIED = 'access_denied',
  UNSUPPORTED_RESPONSE_TYPE = 'unsupported_response_type',
  INVALID_SCOPE = 'invalid_scope',
  INVALID_GRANT = 'invalid_grant',
  SERVER_ERROR = 'server_error',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
  INTERACTION_REQUIRED = 'interaction_required',
  LOGIN_REQUIRED = 'login_required',
  ACCOUNT_SELECTION_REQUIRED = 'account_selection_required',
  CONSENT_REQUIRED = 'consent_required',
  INVALID_REQUEST_URI = 'invalid_request_uri',
  INVALID_REQUEST_OBJECT = 'invalid_request_object',
  REQUEST_NOT_SUPPORTED = 'request_not_supported',
  REQUEST_URI_NOT_SUPPORTED = 'request_uri_not_supported',
  REGISTRATION_NOT_SUPPORTED = 'registration_not_supported',
  CAPTCHA_REQUIRED = 'captcha_required',
  CAPTCHA_INVALID = 'captcha_invalid',
  // 身份源/登录方式相关错误
  PROVIDER_NOT_ENABLED = 'provider_not_enabled',
  LOGIN_METHOD_DISABLED = 'login_method_disabled',
  // 扩展的凭据相关错误码（服务端实际返回格式）
  INVALID_USERNAME_OR_PASSWORD = 'invalid_username_or_password',
  INVALID_CREDENTIALS = 'invalid_credentials',
  WRONG_PASSWORD = 'wrong_password',
  USER_NOT_FOUND = 'user_not_found',
  // 自定义业务错误码（数字），用于 getVerification 等接口
  MFA_PHONE_REQUIRED = 'mfa_phone_required',
  LOGIN_TYPE_DISABLED = 'login_type_disabled',
  PROVIDER_ERROR = 'provider_error',
}

/**
 * getVerification / verify 接口可能返回的数字错误码
 * 对应服务端 pbcommon.CommonError 和 gRPC status code
 */
export enum AuthErrorCode {
  /** gRPC: invalid_argument - 参数校验失败（验证码过期/不正确、参数缺失等） */
  INVALID_ARGUMENT = 3,
  /** gRPC: not_found - 资源未找到（用户不存在等） */
  NOT_FOUND = 5,
  /** gRPC: permission_denied */
  PERMISSION_DENIED = 7,
  /** gRPC: resource_exhausted - 发送频率限制 */
  RESOURCE_EXHAUSTED = 8,
  /** gRPC: failed_precondition - 前置条件不满足（账号已绑定等） */
  FAILED_PRECONDITION = 9,
  /** gRPC: aborted - 操作被中止 */
  ABORTED = 10,
  /** gRPC: unimplemented - 功能未实现 */
  UNIMPLEMENTED = 12,
  /** gRPC: internal - 内部错误 */
  INTERNAL = 13,
  /** gRPC: unavailable - 服务不可用 */
  UNAVAILABLE = 14,
  /** gRPC: unauthenticated - Token 校验失败 */
  UNAUTHENTICATED = 16,
  /** 业务码: 需要验证码(滑块) */
  CAPTCHA_REQUIRED = 4001,
  /** 业务码: 验证码(滑块)校验失败 */
  CAPTCHA_INVALID = 4002,
  /** 业务码: provider 相关错误 */
  PROVIDER_ERROR = 4019,
  /** 业务码: unauthorized_client */
  UNAUTHORIZED_CLIENT = 4022,
  /** 业务码: MFA 手机号绑定要求 */
  MFA_PHONE_REQUIRED = 4042,
  /** 业务码: 登录方式被禁用 */
  LOGIN_TYPE_DISABLED = 4045,
}

export const LOGIN_STATE_CHANGED_TYPE = {
  SIGN_OUT: 'sign_out',
  SIGN_IN: 'sign_in',
  CREDENTIALS_ERROR: 'credentials_error',
}

export const AUTH_STATE_CHANGED_TYPE = {
  SIGNED_OUT: 'SIGNED_OUT',
  SIGNED_IN: 'SIGNED_IN',
  INITIAL_SESSION: 'INITIAL_SESSION',
  PASSWORD_RECOVERY: 'PASSWORD_RECOVERY',
  TOKEN_REFRESHED: 'TOKEN_REFRESHED',
  USER_UPDATED: 'USER_UPDATED',
  BIND_IDENTITY: 'BIND_IDENTITY',
}

export const EVENTS = {
  // 登录态改变后触发
  LOGIN_STATE_CHANGED: 'loginStateChanged',
  // 授权态改变后触发
  AUTH_STATE_CHANGED: 'authStateChanged',
}

export const OAUTH_TYPE = {
  SIGN_IN: 'sign_in',
  BIND_IDENTITY: 'bind_identity',
}

export const DEFAULT_NODE_ACCESS_SCOPE = 'node-sdk-scope'

/**
 * getVerification 接口的 usage 取值（验证码用途语义）。
 * 用于标识本次验证码的业务场景，服务端据此区分模板/校验策略。
 */
export enum VerificationUsage {
  /** 通用邮箱验证码：注册、登录(OTP)、换绑邮箱、重发 */
  EMAIL = 'email',
  /** 密码找回（resetPasswordForEmail） */
  RECOVERY = 'recovery',
  /** 重新认证（reauthenticate） */
  REAUTHENTICATION = 'reauthentication',
}
